<template>
  <div class="quotation">
    <img class="background" :src="background" alt="">
    <div>
      <img class="title" :src="title" alt="">
      <div class="date-board">
        <img class="date" :src="date" alt="">
        <span class="date-label">2019-01-01至2019-03-01</span>
      </div>
      <div style="text-align: center"><img class="backgroundicon" :src="backgroundicon" alt=""></div>
      <img class="head" :src="head" alt="">
    </div>

    <div class="introduction">
      <div class="subTitle"><span class="smallTitle">活动说明</span> </div>
      <div class="text-board-active">
        <div class="text-active">
           <p style="text-indent: 2em;">1、全系产品首付立减2000元，超低爆款车型首付低至4000元</p>
        </div>
      </div>
    </div>

    <!--循环开始-->
    <div v-for="(productName, i) in Object.keys(tableDataMap)" :key="i">
      <div class="product-type"><span class="product-title">{{productName}}</span></div>
      <div v-for="(obj, index) in Object.keys(tableDataMap[productName])" :key="index">
        <p class="table-title">{{obj}}</p>
        <div class="table-board">
          <table class="report-table" cellspacing="0">
            <tr class="tabel-head">
              <th rowspan="2">品牌</th>
              <th rowspan="2">型号</th>
              <th rowspan="2">指导价</th>
              <th rowspan="2">期数</th>
              <th colspan="2">首付</th>
              <th colspan="2">月还</th>
            </tr>
            <tr class="tabel-head">
              <th>原首付</th>
              <th>现首付</th>
              <th>原月还</th>
              <th>现月还</th>
            </tr>
            <tr class="tabel-body" v-for="(item, index) in tableDataMap[productName][obj]" :key="index">
              <td>{{item.brand}}</td>
              <td>{{item.series}}</td>
              <td>{{item.guidePrice}}</td>
              <td>{{item.period}}</td>
              <td class="number" style="color:#9B9B9B">{{item.lowerDownPayment || '-- --'}} </td>
              <td class="number">{{item.lowerMonthPay || '-- --'}}</td>
              <td class="number" style="color:#9B9B9B">{{item.highDownPayment || '-- --'}}</td>
              <td class="number">{{item.highMonthPay || '-- --'}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!--循环结束-->
    <div class="introduction">
      <div class="subTitle"><span class="smallTitle">产品说明</span> </div>
      <div class="text-board">
        <div class="text">
          <p>1. 该产品单由1月1日正式生效，截止日期另行通知</p>
          <p>2. 该产品实行《功夫好车客户经理提成试行办法2020H1（全国通用版）》，请仔细阅读对照</p>
          <p>3. 拉萨产品只实用于拉萨地区，其他地区产品已全国为准</p>
        </div>
      </div>

    </div>
    <div class="footer">
      <img :src="logo" alt="logo">
    </div>
  </div>
</template>

<script>
import background from '@/assets/quotation/background.png';
import title from '@/assets/quotation/title.png';
import backgroundicon from '@/assets/quotation/backgroundicon.png';
import date from '@/assets/quotation/date.png';
import head from '@/assets/quotation/head.png';
import logo from '@/assets/quotation/logo.png';
import data from './data.json';
export default {
  name: 'Poster',
  data () {
    return {
      background,
      title,
      backgroundicon,
      date,
      head,
      logo,
      tableDataMap: {}
    };
  },
  created () {
    this.tableDataMap = this.groupByProductName(data);
  },
  methods: {
    groupByProductName (data) {
      const Map = {};
      data.forEach(item => {
        if (Map[item.productName]) {
          if (Map[item.productName][item.area]) {
            Map[item.productName][item.area].push(item);
          } else {
            Map[item.productName][item.area] = [item];
          }
        } else {
          Map[item.productName] = {
            [item.area]: [item]
          };
        }
      });
      console.log(Map);
      return Map;
    },
    handleFocus () {
      this.$router.push('/pricing/result/series');
    }
  }
};

</script>

<style scoped lang="scss">
  img {
    content: normal !important;
    display: inline-block;
  }

  .quotation {
    position: relative;
    background-color: #FFF3BE;
    width: 100%;

    .background {
      width: 100%;
      position: relative;
    }

    .title {
      height: 174px;
      position: absolute;
      top: 66px;
      left: 170px;
    }

    .date-board {
      top: 254px;
      left: 160px;
      width: 60%;
      position: absolute;

      .date {
        width: 100%;
      }

      .date-label {
        position: absolute;
        top: 30px;
        left: 60px;
        font-size: 28px;
        font-weight: bold;
        font-family: PingFangSC-Medium;
        color: rgba(0, 0, 0, 1);
      }
    }

    .backgroundicon {
      left: 194px;
      top: 320px;
      width: 50%;
      position: absolute;
    }

    .head {
      left: 0px;
      top: 352px;
      position: absolute;
      width: 100%;
    }

    .introduction {
      padding: 27px 50px 0 50px;

      .subTitle {
        text-align: center;

        .smallTitle {
          display: inline-block;
          width: 200px;
          height: 50px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 4px 6px 0px rgba(121, 67, 0, 0.29);
          border-radius: 25px;
          border: 2px solid rgba(58, 55, 62, 1);
          margin-bottom: 20px;
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(0, 0, 0, 1);
          line-height: 50px;
          font-weight: bold;
        }
      }

      .text-board {
        .text {
          font-size: 24px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 33px;

          p {
            padding-bottom: 10px;
          }
        }
      }

      .text-board-active {
        .text-active {
          font-size: 24px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 33px;
        }
      }
    }

    .product-type {
      text-align: center;
      margin-top: 27px;

      .product-title {
        display: inline-block;
        width: 340px;
        height: 50px;
        background: rgba(242, 74, 72, 1);
        box-shadow: 0px 4px 6px 0px rgba(220, 0, 40, 0.28);
        border-radius: 2px;
        border: 2px solid rgba(0, 0, 0, 1);
        font-size: 30px;
        font-weight: bold;
        font-family: PingFangSC-Semibold;
        color: rgba(255, 255, 255, 1);
        line-height: 50px;
        letter-spacing: 1px;
      }
    }

    .table-title {
      margin: 20px 0;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: bold;
    }

    .table-board {
      margin: 0 auto;
      width: 95%;
      overflow-x: scroll;

      .report-table {
        width: 100%;
        background-color: #fff;
        font-size: 22px;
        font-family: PingFangSC-Semibold;
        font-weight: bold;
        border-collapse: collapse;
        border: 1px solid #a5a5a5;

        .tabel-head {
          background-color: #FFEA32;
          font-weight: 700;

          th {
            border-collapse: collapse;
            border: 1px solid #a5a5a5;
          }
        }

        .tabel-body {
          text-align: center;

          .number {
            white-space: nowrap;
          }

          td {
            padding: 5px;
            border-collapse: collapse;
            border: 1px solid #a5a5a5;
          }
        }
      }
    }

    .footer {
      height: 80px;
      line-height: 80px;
      background: rgba(0, 0, 0, 1);
      margin-top: 60px;
      text-align: center;
    }
  }

</style>
